import styled from '@emotion/styled';

const Title = styled.h1`
    font-family: 'Roboto', sans-serif;
    color: #607179;
    font-size: 1rem;
    font-weight: 500;
    line-height: 24px;
    margin-top: 0;
`;

const ComingSoonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    border-radius: 8px;
    margin-top: 10px;
`;

const ComingSoonText = styled.h2`
    font-family: 'Roboto', sans-serif;
    color: #3f51b5;
    font-size: 1.5rem;
    font-weight: 500;
    margin-bottom: 0.5rem;
`;

const ComingSoonDescription = styled.p`
    font-family: 'Roboto', sans-serif;
    color: #607179;
    font-size: 1rem;
    text-align: center;
    max-width: 80%;
`;

const Recents = ({ handleCall, auth }) => {
    return (
        <div className="h-full px-2">
            <Title>Recents</Title>
            <ComingSoonWrapper>
                <ComingSoonText>Coming Soon...</ComingSoonText>
                <ComingSoonDescription>
                    We're working on bringing you a list of your recent calls.
                    Stay tuned for updates!
                </ComingSoonDescription>
            </ComingSoonWrapper>
        </div>
    );
};

export default Recents;
